/** Format helpers — WhatsApp / phone links. */

export function whatsappHref(phone) {
    // Strip everything that is not a digit; wa.me expects digits only.
    const digits = String(phone || "").replace(/[^\d]/g, "");
    return `https://wa.me/${digits}`;
}

export function telHref(phone) {
    const digits = String(phone || "").replace(/[^\d+]/g, "");
    return `tel:${digits}`;
}

/**
 * Backend contact form contract requires domain="burkina-canada" for cross-border
 * routing. Our practice areas store that concept under the slug
 * "dossiers-transfrontaliers-burkina-canada". This helper maps the practice slug
 * to the value that must be posted.
 */
export function domainOptionValue(slug) {
    if (slug === "dossiers-transfrontaliers-burkina-canada") {
        return "burkina-canada";
    }
    return slug;
}
